var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFolderOpenGrey(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "folder-open-line",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23175",
    "data-name": "Path 23175",
    d: "M0,0H15V15H0Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23176",
    "data-name": "Path 23176",
    d: "M2.628,14.354A.629.629,0,0,1,2,13.724V3.631A.629.629,0,0,1,2.628,3H7.284L8.54,4.262H13.3a.629.629,0,0,1,.628.631V6.785H12.676V5.523H8.02L6.764,4.262H3.256V11.83L4.2,8.046H14.873l-1.451,5.831a.629.629,0,0,1-.609.478ZM13.265,9.308H5.179l-.942,3.785h8.086Z",
    transform: "translate(-0.785 -1.177)",
    fill: "#2e384d"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderOpenGrey);
export default __webpack_public_path__ + "static/media/folder-open-grey.19e8f2c3a7f73f38e7457cf10e0d65ea.svg";
export { ForwardRef as ReactComponent };